export default "__VITE_ASSET__BRyP0mt5__"